import authOrCreateMessage from 'actions/messages/authOrCreateMessage';
import onboardIfNeeded from 'actions/user/onboardIfNeeded';
import uiEnums from 'enums/ui';
import updateEmail from 'actions/user/updateEmail';
import updateName from 'actions/user/updateName';

const submitComposition = (currentCompositionStage, text, attachments) => {
  return dispatch => {
    if (currentCompositionStage === uiEnums.COMPOSITION_STAGES.EMAIL) {
      dispatch(updateEmail(text));
      dispatch(onboardIfNeeded());
    } else if (currentCompositionStage === uiEnums.COMPOSITION_STAGES.NAME) {
      dispatch(updateName(text));
      dispatch(onboardIfNeeded());
    } else if (currentCompositionStage === uiEnums.COMPOSITION_STAGES.MESSAGE) {
      dispatch(authOrCreateMessage(text, attachments));
      return;
    }
  };
};

export default submitComposition;
